<template>

    <div class="row" v-if="loaded">
        <div class="col-sm-3">
            <div class="box box-solid">
                <div class="box-body box-profile">
                    <strong
                        v-if="profileImg === null"
                        class="text-logo user-image img-circle"
                        style="width:100px;margin:0 auto;padding-top:35px;"
                    ><span>{{ firstLetter }}</span></strong>
                    <img
                        v-else
                        :src="route('users.profile-image', user.uuid)"
                        class="profile-user-img img-responsive img-circle"
                        :alt="user.name"
                    />

                    <h3 class="profile-username text-center">
                        {{ user.name }}
                    </h3>

                    <p class="text-muted text-center">
                        {{ user.code }}
                    </p>

                    <ul class="list-group list-group-unbordered">
                        <li class="list-group-item">
                            <b>E-mailadres</b>
                            <a
                                :href="'mailto:' + user.email"
                                class="pull-right"
                            >
                                {{ user.email }}
                            </a>
                        </li>
                        <li class="list-group-item">
                            <b>Aantal projecten</b>
                            <a class="pull-right">{{ user.project_count }}</a>
                        </li>
                    </ul>

                    <div v-if="canEditUser">
                        <div class="btn-group">
                            <router-link
                                class="btn btn-default"
                                :to="{name:'hr.users.show', params:{uuid:user.uuid}}"
                                v-tooltip="'Gebruiker bekijken in de HR module'"
                            >
                                <i class="mdi mdi-eye"></i>
                                <span class="sr-only">Gebruiker bekijken in de HR module</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <loader v-else></loader>

</template>

<script>

import axios from 'axios';
import { mapGetters } from 'vuex';
import Loader from "../../components/Common/Loader";

export default {

    components: {
        Loader,
    },

    computed: {

        ...mapGetters([
            'hasLicense',
        ]),

        canEditUser() {
            return this.hasLicense('hr');
        },

        firstLetter() {
            if (!this.user.firstname) {
                return '';
            }
            return this.user.firstname.substring(0, 1);
        },

        profileImg() {
            if (!this.user.src) {
                return null;
            }
            return this.user.src;
        },
    },

    data() {
        return {
            loaded:false,
            user:{},
        }
    },

    metaInfo: {
        title:'Gebruikersprofiel',
    },

    methods: {
        getUserProfile() {
            axios.get(this.route('api.v1.social.userprofile', {uuid:this.$route.params.uuid}))
                .then(resp => {
                    this.user = resp.data.data;
                    this.loaded = true;
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het ophalen van het profiel'));
        },
    },

    mounted(){
        this.getUserProfile();
    },

    name:'SocialUserProfile',

}

</script>
